export default __webpack_public_path__ + "static/media/tool1.77c54031.png";